export default (props, vars) => props?.['children'] && props?.['children']();
